/**
 * Copyright (C) 2021 - 2023 Philips Domestic Appliances Holding B.V.
 * All rights are reserved.
 */

import { Injectable } from '@angular/core';

import { of } from 'rxjs';

@Injectable()
export class DataResolver {
	public resolve() {
		return of({ res: 'I am data' });
	}
}

// an array of services to resolve routes with data
export const APP_RESOLVER_PROVIDERS = [DataResolver];
